import axios from "axios";

import { URL, getUrl } from "@api/constants";

class SnapshotClient {

  makeSnapshot(deviceSerial, channels) {
    return axios.post(getUrl(URL.POST_SNAPSHOT), {
      deviceSerial,
      channels
    });
  }
  
}

export let snapshotClient = new SnapshotClient();



// WEBPACK FOOTER //
// ./src/api/snapshot.js